module.exports = __webpack_public_path__ + "img/30_55.d8c162c2.png";